export default __webpack_public_path__ + "d900a5d54614fa5545aafc7538e3614b.png";